export default () => value => (value ? he.escape(value) : value);



// WEBPACK FOOTER //
// src/app/common/filters/escape.filter.ts